module.exports = __webpack_public_path__ + "static/media/rainbowRing.86333f3e.svg";